// styles.js
import styled, { css } from 'styled-components';

/* Layout */
export const Page = styled.div`
  min-height: 100vh;
`;

export const Container = styled.div`
  max-width: 64rem; /* ~1024px */
  margin: 0 auto;
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0.75rem 2rem;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 1rem;
  border: 0;
  cursor: pointer;
  box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease;

  ${p =>
    p.disabled
      ? css`
          background: #d1d5db; /* gray-300 */
          color: #6b7280; /* gray-500 */
          cursor: not-allowed;
        `
      : css`
          background: #005d1f;
          color: #fff;

          &:hover {
            box-shadow: 0 12px 20px -5px rgba(0, 0, 0, 0.15),
              0 6px 8px -3px rgba(0, 0, 0, 0.06);
          }
        `}

  @media (min-width: 640px) {
    width: auto;
    padding: 1rem 3rem;
    font-size: 1.125rem;
  }
`;

/* Balance Card */
export const BalanceCard = styled.div`
  background: #005d1f; /* green-800 */
  color: #fff;
  border: 0;
  border-radius: 1rem;
  margin-bottom: 2rem;

  @media (min-width: 640px) {
    margin-bottom: 3rem;
  }
`;

export const BalanceContent = styled.div`
  padding: 15px 24px;
  text-align: center;

  @media (min-width: 640px) {
    padding: 2rem;
  }
`;

export const BalanceHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  h2 {
    margin: 0;
    font-weight: 500;
    font-size: 16px;
  }
`;

export const BalanceSub = styled.p`
  color: #ffffff;
  margin-bottom: 16px;
  font-size: 16px;
`;

export const BalanceValue = styled.p`
  margin: 0;
  font-weight: 700;
  font-size: 32px;
`;

/* Section Title */
export const SectionTitle = styled.h2`
  text-align: center;
  color: #005d1f;
  margin: 0 0 8px 0;
  font-weight: 600;
  font-size: 24px;
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  color: #231f20;
  margin: 0 0 30px 0;
  font-weight: 400;
  font-size: 16px;
`;

/* Transfer Options */
export const OptionsList = styled.div`
  display: grid;
  gap: 0.75rem;
  margin-bottom: 2rem;

  @media (min-width: 640px) {
    gap: 1rem;
  }
`;

export const OptionCard = styled.div`
  background: #ffffff;
  border: 1px solid ${p => (p.$selected ? '#005D1F' : '#9FA4AA')};
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease;

  &:hover {
    transform: translateY(-1px);
  }

  padding: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;

  @media (min-width: 640px) {
    gap: 1rem;
  }
`;

export const IconBubble = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    object-fit: contain;
    display: block;
  }
  .size-interac {
    width: 100%;
    height: 100%;
  }
  .size-visa {
    width: 100%;
    height: 100%;
  }
  .size-mc {
    width: 100%;
    height: 100%;
  }
`;

export const OptionBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const OptionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;

  h3 {
    margin: 0;
    color: #231f20;
    font-weight: 600;
    font-size: 18px;

    @media (min-width: 640px) {
      font-size: 1.25rem;
    }
  }
`;

export const InfoIconButton = styled.button`
  padding: 0.25rem;
  border-radius: 9999px;
  border: 0;
  background: transparent;
  cursor: pointer;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #e5e7eb;
  }
  svg {
    color: #6b7280;
  }
`;

export const Description = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-bottom: 16px;

  .row {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .dot {
    color: #000000;
    font-weight: 700;
    line-height: 1;
  }

  a {
    color: #255d38;
    text-decoration: underline;
    font-weight: 400;
    cursor: pointer;
  }

  b {
    font-weight: 600;
  }
`;

export const Fee = styled.p`
  margin: 0;
  color: #000000;
  font-size: 14px;
  font-weight: 500;

  a {
    color: #255d38;
    text-decoration: underline;
    font-weight: 500;
    cursor: pointer;
  }
`;

export const RadioWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  input[type='radio'] {
    width: 1.5rem;
    height: 1.5rem;
    border: 2px solid #9ca3af; /* gray-400 */
    accent-color: #005d1f;
  }
`;

export const ContinueWrap = styled.div`
  text-align: center;
  padding: 0 1rem;
  margin-bottom: 2rem;
`;

export const DynamicText = styled.p`
  text-align: center;
  margin-top: 1rem;
  color: #4b5563; /* gray-600 */
  font-size: 0.95rem;

  @media (min-width: 640px) {
    font-size: 1rem;
  }
`;

/* Termination overlay */
export const TerminatedWrap = styled.div`
  min-height: 100vh;
  background: #fff3cd; /* amber-100-ish */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
`;

export const TerminatedCard = styled.div`
  max-width: 42rem;
  width: 100%;
  background: #ffffff;
  border: 1px solid #ffeaa7;
  border-radius: 0.75rem;
  color: #856404;
  padding: 1.5rem;

  h2 {
    margin: 0 0 0.75rem 0;
  }
  p {
    margin: 0 0 0.75rem 0;
    line-height: 1.55;
  }

  .actions {
    display: flex;
    gap: 0.75rem;
    justify-content: center;
    margin-top: 1rem;
  }

  .danger {
    background: #e74c3c;
    color: #fff;
    border: 0;
    padding: 0.75rem 1.25rem;
    border-radius: 0.5rem;
    cursor: pointer;
  }
  .muted {
    background: #95a5a6;
    color: #fff;
    border: 0;
    padding: 0.75rem 1.25rem;
    border-radius: 0.5rem;
    cursor: pointer;
  }
`;

/* ========= Styled modal (custom confirm) ========= */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalCard = styled.div`
  width: min(560px, 92vw);
  background: #fff5f5; /* very light red */
  border: 1px solid #fecaca; /* red-200 */
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  padding: 20px;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  font-weight: 700;
  color: #b91c1c; /* red-700 */
  font-size: 18px;
`;

export const RoundIcon = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  background: #ef4444; /* red-500 */
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
`;

export const ModalBody = styled.div`
  color: #7f1d1d; /* red-900-ish */
  font-size: 14px;
  line-height: 1.55;
`;

export const Section = styled.div`
  background: ${p => (p.$tone === 'danger' ? '#ffe4e6' : '#fff7ed')};
  border-left: 4px solid ${p => (p.$tone === 'danger' ? '#dc2626' : '#f59e0b')};
  border-radius: 8px;
  padding: 12px 14px;
  margin: 12px 0;
`;
export const ModalSectionTitle = styled.div`
  color: ${p => (p.$tone === 'danger' ? '#b91c1c' : '#b45309')};
  font-weight: 700;
  margin-bottom: 6px;
`;
export const Bullets = styled.ul`
  margin: 0;
  padding-left: 18px;
  li {
    margin: 4px 0;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-top: 14px;
  flex-wrap: wrap;
`;

export const DangerButton = styled.button`
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
`;

export const NeutralButton = styled.button`
  background: #64748b;
  color: white; /* slate-500 */
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
`;
